<template>
  <section className="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="Math.random()" :smallWidth="smallWidth" :screenWidth="screenWidth"/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "indexMain",
  props: {
    smallWidth: {
      type: Number
    },
    screenWidth: {
      type: Number
    }
  },
  methods: {
    key() {
      return this.$route.path
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/components/indexMain.vue